module.exports = __webpack_public_path__ + "static/img/cont66 (2).e7cf7b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont66 (2).jpg
// module id = IMnU
// module chunks = 0